/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SelectionInverse(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M152,216a8.00008,8.00008,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8.00008,8.00008,0,0,1,152,216ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM224,48a16.01833,16.01833,0,0,0-16-16H48a15.9167,15.9167,0,0,0-10.66406,4.106,7.68793,7.68793,0,0,0-1.23023,1.23022A15.917,15.917,0,0,0,32,48V72a8,8,0,0,0,16,0V59.31348L196.68555,208H184a8,8,0,0,0,0,16h24a15.9162,15.9162,0,0,0,10.66284-4.105,7.68852,7.68852,0,0,0,1.23145-1.2312A15.917,15.917,0,0,0,224,208Z" />
    </Svg>
  );
}

export default SelectionInverse;
